import { createI18n } from 'vue-i18n'
import { en } from './en.js'
import { zh } from './zh.js'
import { ja } from './ja.js'
import { es } from './es.js'
import { id } from './id.js'
import { pt } from './pt.js'

export const adminMessages = { en, zh, ja, es, id, pt }

/**
 * @param {{ locale: string }} opts
 */
export function createAdminI18n(opts) {
  const locale = Object.hasOwn(adminMessages, opts.locale) ? opts.locale : 'zh'
  const i18n = createI18n({
    legacy: false,
    locale,
    fallbackLocale: 'en',
    messages: adminMessages,
  })
  return {
    i18n,
    getLocale: () => i18n.global.locale.value,
    setLocale(nextLocale) {
      if (!Object.hasOwn(adminMessages, nextLocale)) {
        throw new Error(`Unsupported locale: ${nextLocale}`)
      }
      i18n.global.locale.value = nextLocale
    },
  }
}
